import { render } from "./topFavorites.vue?vue&type=template&id=7b958fb8&scoped=true&lang=html"
import script from "./topFavorites.vue?vue&type=script&lang=js"
export * from "./topFavorites.vue?vue&type=script&lang=js"

import "./topFavorites.vue?vue&type=style&index=0&id=7b958fb8&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b958fb8"]])

export default __exports__